module.exports = "https://web-assets.ifttt.com/packs/media/home/get-started-tree-3x-0015f8f3.png";